import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import MainLoader from '../../../components/Loaders/MainLoader';
import InputForm from '../../../components/Inputs/formInput/InputForm';
import BtnContent from '../../../components/buttons/BtnContent';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import DropdownForm from '../../../components/Inputs/formInput/DropdonwForm';
import Error from '../../../components/errors/Error';
//SLICES
import { getLevelThunk, initialStateLevel, updateLevelThunk, createLevelThunk } from '../../../store/slices/catalogs/levels.slice';
import { getCourseThunk, initialStateCourse, createCourseThunk, updateCourseThunk } from '../../../store/slices/catalogs/courses.slice';



const CoursesForm = () => {
    const { t } = useTranslation();
    let navigate = useNavigate();
    let { course_id } = useParams();
    const { setValue, register, handleSubmit, formState: { errors } } = useForm();
    const { item, message, error } = useSelector(state => state.courses);
    const isLoading = useSelector(state => state.isLoadingSlice);
    const dispatch = useDispatch();


    useEffect(() => {
        if (course_id) {
            dispatch(getCourseThunk(course_id));
        }
        return () => {
            dispatch(initialStateCourse());
        };
    }, []);

    const onSubmit = (data) => {
        if (course_id) {
            dispatch(updateCourseThunk(course_id, data));
        } else {
            dispatch(createCourseThunk(data));
        }
    };

    if (message === "Registro creado correctamente " || message === "Registro actualizado correctamente ") {
        navigate(`/panel/courses`);
    }

    if (Object.keys(item).length !== 0) {
        setValue('name', item?.name)
    }

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className="w-[96%] mt-5 ml-5 ">
                    {error ? <Error state={error} /> : " "}
                    <HeaderForm title={course_id ? "Editar curso" : "Nuevo curso"} />
                    <div className='h-[90%]'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='flex gap-2 p-2'>
                                <InputForm
                                    spam={true}
                                    label={t("Nombre")}
                                    input="input"
                                    type="text"
                                    cols={1}
                                    register={register("name", { required: true })}
                                    errors={errors.name && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
    
                            </div>
                            <div className="flex items-center justify-start py-5 gap-2 border-t-2 border-p-green mt-8">
                                <BtnContent type="submit">{t("save_button")}</BtnContent>
                                <BtnContent cancel={true} to={`/panel/courses`}>{t("canceled_button")}</BtnContent>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default CoursesForm;